const defaultFields = [
  {
    key: 'id',
    field: 'id',
    title: 'id',
    label: 'id',
    cell: 'navigation',
    sortable: true,
	 },
  {
    key: 'name',
    field: 'name',
    title: 'name',
    label: 'name',
    sortable: true,
	 },
  {
    key: 'createdByUserId',
    field: 'createdByUserId',
    title: 'createdByUserId',
    label: 'createdByUserId',
    sortable: true,
	 },
  {
    key: 'modifiedByUserId',
    field: 'modifiedByUserId',
    title: 'modifiedByUserId',
    label: 'modifiedByUserId',
    sortable: true,
	 },
  {
    key: 'dateCreated',
    field: 'dateCreated',
    title: 'dateCreated',
    label: 'dateCreated',
    cell: 'formatDate',
    sortable: true,
	 },
  {
    key: 'dateModified',
    field: 'dateModified',
    title: 'dateModified',
    label: 'dateModified',
    cell: 'formatDate',
    sortable: true,
	 },
  {
    key: 'active',
    field: 'active',
    title: 'active',
    label: 'active',
    sortable: true,
	 },

]

export default defaultFields;
